import React from 'react'
import { FaCircleUser } from 'react-icons/fa6'
import "./ProfileBanner.css";
import { Link, useNavigate } from 'react-router-dom';

const ProfileBanner = ({ bannerName, rightIcon, leftIcon }) => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1); // This goes one step back in history
      };
    return (
        <>
            <section>
                <div className='container profile-sec-div'>
                    <label onClick={handleGoBack}>
                        {leftIcon !== '' ? (
                                <label className='profile-banner-left'>
                                    {leftIcon}
                                </label>
                        ) : ""}
                        {bannerName}
                    </label>
                    <label>
                        {rightIcon}

                    </label>
                </div>
            </section>
        </>
    )
}

export default ProfileBanner